import { createContext, useContext } from 'react'
import { Session } from '@/api/models/UserModel'

type SessopmContextProps = {
  session: Session
}

export const SessionContext = createContext<SessopmContextProps>({} as SessopmContextProps)

export const useSession = () => {
  const context = useContext(SessionContext)
  return context
}
